<div class="page catalogue-page">
  <h1>Data Catalogue</h1>

  <!-- Main tabs -->
  <div class="main-tabs">
    <button
      type="button"
      class="main-tab"
      [class.active]="activeMainTab === 'catalogue'"
      (click)="activeMainTab = 'catalogue'">
      Catalogue
    </button>

    <button
      type="button"
      class="main-tab"
      [class.active]="activeMainTab === 'tables'"
      (click)="activeMainTab = 'tables'">
      Tables
    </button>
  </div>

  <!-- ===================== -->
  <!-- CATALOGUE TAB CONTENT -->
  <!-- ===================== -->
  <div *ngIf="activeMainTab === 'catalogue'" class="tab-panel">
    <div class="card" (click)="$event.stopPropagation()">
      <div class="chart-title-row">
        <h2>Data Catalogue</h2>
      </div>

      <p class="desc-intro">
        Structured inventory of dashboard fields (definitions, types, mappings, terminology sources, and permissible values).
      </p>

      <section *ngIf="catalogueLoading" class="status status--loading">
        Loading data catalogue…
      </section>

      <section *ngIf="catalogueError" class="status status--error">
        {{ catalogueError }}
      </section>

      <div *ngIf="catalogueData && !catalogueLoading && !catalogueError" class="table-block">
        <h3 class="table-title">
          Data Catalogue ({{ catalogueData.rows.length }} fields)
        </h3>

        <div class="worklist-table-wrap">
          <table class="worklist-table" *ngIf="catalogueData.rows.length; else emptyCatalogue">
            <thead>
              <tr>
                <th *ngFor="let h of catalogueData.headers">
                  {{ h }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let row of catalogueData.rows">
                <td *ngFor="let cell of row">
                  {{ cell }}
                </td>
              </tr>
            </tbody>
          </table>

          <ng-template #emptyCatalogue>
            <p class="hint">No catalogue rows found.</p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- ================= -->
  <!-- TABLES TAB CONTENT -->
  <!-- ================= -->
  <div *ngIf="activeMainTab === 'tables'" class="tab-panel">
    <div class="card" (click)="$event.stopPropagation()">
      <div class="chart-title-row">
        <h2>Tables</h2>
      </div>

      <p class="desc-intro">
        Synthetic source tables used by the prototype.
      </p>

      <!-- Workbook-style table toggles -->
      <div class="table-toggles">
        <button
          type="button"
          *ngFor="let t of tables"
          class="table-toggle"
          [class.active]="selectedTable?.id === t.id"
          (click)="selectTable(t)">
          {{ t.label }}
        </button>
      </div>

      <!-- Loading / error states -->
      <section *ngIf="isLoading" class="status status--loading">
        Loading table…
      </section>

      <section *ngIf="error" class="status status--error">
        {{ error }}
      </section>

      <!-- Rendered table -->
      <div *ngIf="tableData && !isLoading && !error" class="table-block">
        <h3 class="table-title">
          {{ selectedTable?.label }} ({{ tableData.rows.length }} rows)
        </h3>

        <div class="worklist-table-wrap">
          <table class="worklist-table" *ngIf="tableData.rows.length; else emptyTable">
            <thead>
              <tr>
                <th *ngFor="let h of tableData.headers">
                  {{ h }}
                </th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let row of tableData.rows">
                <td *ngFor="let cell of row">
                  {{ cell }}
                </td>
              </tr>
            </tbody>
          </table>

          <ng-template #emptyTable>
            <p class="hint">No rows found for this table.</p>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</div>
